export const tierPricing = [
  { tier: 1, rrp: 40, pricePerWeek: 4.99, insurancePricePerWeek: 2.99 },
  { tier: 2, rrp: 80, pricePerWeek: 6.99, insurancePricePerWeek: 3.99 },
  { tier: 3, rrp: 120, pricePerWeek: 9.99, insurancePricePerWeek: 4.99 },
  { tier: 4, rrp: 99999, pricePerWeek: 13.99, insurancePricePerWeek: 6.99 },
]

export const setWeeklyPrice = (rrp:number) => {
  const targetSaving = 92                             // Percentage saving
  const baseAdjustment = 1.99                         // Base adjustment to ensure cheap sets aren't too cheap
  const denominationsPerPound = 2                     // This is used to specify the number of divisions per pound, 
                                                      // ultimately resulting in what x.x9 price appears:
                                                      // 1 = whole numbers only, e.g. 3.99
                                                      // 2 = 50p denominations,  e.g. 3.49, 3.99
                                                      // 3 = 33p denominations,  e.g. 3.33, 3.66, 3.99
                                                      // 4 = 25p denominations,  e.g. 3.24, 3.49, 3.74, 3.99
                                                      // 5 = 20p denominations,  e.g. 3.19, 3.39, 3.59, 3.79, 3.99

  let retval = rrp * (1 - (targetSaving / 100))       // 1. Discounted RRP by the target saving:    £45 RRP becomes £3.375 per week
  retval = Math.ceil(retval * denominationsPerPound)  // 2. Double the weekly price and round up:   £3.375  becomes £7
  retval = retval / denominationsPerPound             // 3. Half the weekly price:                  £7      becomes £3.50
  retval = retval + baseAdjustment                    // 4. Add the base adjustment                 £3.50   becomes £5.49
  return retval
}

export const masterTierThreshold = 150
export const builderTierThreshold = 69

export const setSubscriptionTier = (rrp:number) => rrp > masterTierThreshold
                                                    ? { name: 'Master', twColor: 'text-brand-blue' } 
                                                 : rrp > builderTierThreshold 
                                                    ? { name: 'Builder', twColor: 'text-brand-red' } 
                                                    : { name: 'Hobby', twColor: 'text-brand-yellow' }

export const setShippingPrice = (set:any) => {
  // This is a start, but should probably be based upon hard data,
  // e.g. number of boxes, weight, >£xxx RRP and therefore signature required, amount of RM compensation
  if (set.shippingOverride) return set.shippingOverride

  switch (true) {
    case setWeeklyPrice(set.rrp) > 14.95:
      return 9.95;
    case setWeeklyPrice(set.rrp) > 8.95:
      return 7.95;
    case setWeeklyPrice(set.rrp) > 5.95:
      return 5.95;
    default:
      return 4.95;
  }
}

export const savingAsPercentage = (weeklyRate:number, rrp:number) => Math.round((1 - (weeklyRate / rrp)) * 100)

export const legendaryPricePoint = 80
export const isLegendary = (rrp:number) => rrp >= legendaryPricePoint